import { Container, Typography, Box, Paper } from "@mui/material";
import { useContent } from "../app/ContentContext";

export default function Letter() {
  const { letter } = useContent();
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" align="center" gutterBottom fontWeight="bold">
        {letter.title}
      </Typography>

      <Paper
        elevation={0}
        sx={{
          borderLeft: (theme) => `4px solid ${theme.palette.primary.main}`,
          pl: 2,
          mb: 3,
        }}
      >
        <Typography variant="h6" fontWeight="bold" color="primary.main">
          {letter.subtitle}
        </Typography>
        <Typography fontWeight="bold">{letter.clinicName}</Typography>
        <Typography sx={{ whiteSpace: "pre-line" }}>
          {letter.address}
        </Typography>
        <Typography>{letter.phone}</Typography>
        <Box component="a" href={letter.website} target="_blank" rel="noopener">
          {letter.website}
        </Box>
      </Paper>

      <Typography paragraph>{letter.intro}</Typography>
      <Typography paragraph>{letter.location}</Typography>
      <Typography paragraph>{letter.parking}</Typography>
      <Typography paragraph>{letter.allergy}</Typography>
      <Typography paragraph>{letter.payment}</Typography>
      <Typography paragraph>{letter.cancel}</Typography>

      <Typography paragraph fontWeight="bold">
        {letter.infection}
      </Typography>

      <Typography paragraph fontWeight="bold">
        {letter.closing}
      </Typography>
      <Typography paragraph>{letter.regards}</Typography>
      <Typography paragraph fontWeight="bold">
        {letter.signature}
      </Typography>
      <Typography paragraph>{letter.clinicClosing}</Typography>
    </Container>
  );
}
